"use strict";
// Copyright (c) 2024 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_DECIMALS = exports.TOKEN_ID_NUM_BYTES = exports.UNKNOWN_STR = exports.BURN = exports.BURN_STR = exports.SEND = exports.SEND_STR = exports.MINT = exports.MINT_STR = exports.GENESIS = exports.GENESIS_STR = void 0;
const str_js_1 = require("../io/str.js");
/** GENESIS tx type: Creates a new token ID */
exports.GENESIS_STR = 'GENESIS';
exports.GENESIS = (0, str_js_1.strToBytes)(exports.GENESIS_STR);
/** MINT tx type: Mints more of a token ID */
exports.MINT_STR = 'MINT';
exports.MINT = (0, str_js_1.strToBytes)(exports.MINT_STR);
/** SEND tx type: Moves existing tokens to different outputs */
exports.SEND_STR = 'SEND';
exports.SEND = (0, str_js_1.strToBytes)(exports.SEND_STR);
/** BURN tx type: Destroys existing tokens */
exports.BURN_STR = 'BURN';
exports.BURN = (0, str_js_1.strToBytes)(exports.BURN_STR);
/**
 * UNKNOWN: Placeholder for unknown token types.
 * Note: These may hold valuable tokens, but which aren't recognized.
 * They should be excluded from UTXO selection.
 **/
exports.UNKNOWN_STR = 'UNKNOWN';
/** Number of bytes in a token ID */
exports.TOKEN_ID_NUM_BYTES = 32;
/** How many decimals a token can have at most (SLP/ALP) */
exports.MAX_DECIMALS = 9;
//# sourceMappingURL=common.js.map